import { BankName, ObjectId, Timestamp } from "../../../types";
import { ActivityMeta } from "../types";

export enum ChequeActivityAction {
  None = 0,
  Confirm,
  Deliver,
  Delete,
  Update,
}

export interface ChequeActivityConfirm {
  id: ObjectId;
  confirmed_with: string;
  price: number;
}

export interface ChequeActivityDeliver {
  id: ObjectId;
  confirmed_with: string;
  price: number;
}

export interface ChequeActivityDelete {
  name: string;
  number: string;
  shenase: string;
  bank: BankName;
  account_no: string;
  price: number;
  date: Timestamp;
  confirmed_with?: string;
}

export interface ChequeActivityUpdate {
  id: ObjectId;
  name?: string;
  number: string;
  shenase?: string;
  bank?: BankName;
  account_no?: string;
  price: number;
  date?: Timestamp;
  confirmed_with?: string;
}

export type ChequeActivityData =
  | ChequeActivityConfirm
  | ChequeActivityDeliver
  | ChequeActivityDelete
  | ChequeActivityUpdate;

export interface ChequeActivity {
  action: ChequeActivityAction;
  data: ChequeActivityData;
}

export type ChequeActivityDataWithMeta = {
  activity: ChequeActivityData;
} & ActivityMeta;
